/* eslint-disable react/prop-types */
import React from 'react';
import {
  Form,
  Row,
  Col,
  Input,
} from 'antd';
import Select from '../../Select';

// eslint-disable-next-line react/prop-types
const DescuentoSuspencion = ({
  form,
  rules,
  disableFields,
  periodosNominasDetalles = [],
  suspencionDefinitiva = false,
  setSuspencionDefinitiva,
  suspencionTemporal,
  setSuspencionTemporal,
  isBlocked,
}) => (
  <Form
    layout="vertical"
    form={form}
    scrollToFirstError
    name="general"
    disabled={disableFields}
  >
    <Row gutter={10}>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="es_suspencion_definitiva"
          label="¿Es Suspensión Definitiva?"
          hasFeedback
          rules={rules.required}
          initialValue={false}
        >
          <Select
            trueFalse
            onChange={(value) => {
              setSuspencionDefinitiva(value);
              if (value) {
                setSuspencionTemporal(false);
                form.setFieldsValue({ es_suspencion_temporal: false });
                form.resetFields(['reanudar_periodo_de_nomina_detalle']);
              } else {
                form.resetFields(['inicio_periodo_de_nomina_detalle', 'reanudar_periodo_de_nomina_detalle']);
              }
            }}
            disabled={isBlocked}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="es_suspencion_temporal"
          label="¿Es Suspensión Temporal?"
          hasFeedback
          rules={rules.required}
          initialValue={false}
        >
          <Select
            trueFalse
            onChange={(value) => {
              setSuspencionTemporal(value);
              if (value) {
                setSuspencionDefinitiva(false);
                form.setFieldsValue({ es_suspencion_definitiva: false });
              }
              if (!value) {
                form.resetFields(['inicio_periodo_de_nomina_detalle', 'reanudar_periodo_de_nomina_detalle']);
              }
            }}
            disabled={isBlocked}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="inicio_periodo_de_nomina_detalle"
          label="¿A Partir de qué Nómina se Suspende?"
          rules={(suspencionDefinitiva || suspencionTemporal) ? rules.required : null}
          hasFeedback
        >
          <Select
            keyProp="id"
            labelProp="numero_de_nomina"
            dataSource={periodosNominasDetalles}
            render={(value) => `${value.numero_de_nomina} (${value.fecha_inicial} al ${value.fecha_final})`}
            disabled={(!suspencionDefinitiva && !suspencionTemporal) || isBlocked}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="reanudar_periodo_de_nomina_detalle"
          label="¿En qué Nómina se Reactiva?"
          rules={suspencionTemporal ? rules.required : null}
          hasFeedback
        >
          <Select
            keyProp="id"
            labelProp="numero_de_nomina"
            dataSource={periodosNominasDetalles}
            render={(value) => `${value.numero_de_nomina} (${value.fecha_inicial} al ${value.fecha_final})`}
            disabled={!suspencionTemporal || isBlocked}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={24}>
        <Form.Item
          name="justificacion"
          label="Justificación"
          hasFeedback
        >
          <Input.TextArea
            allowClear
            disabled={disableFields || isBlocked}
          />
        </Form.Item>
      </Col>
    </Row>
  </Form>
);

export default DescuentoSuspencion;
